import React from 'react';
import List from '@mui/material/List';
import { useSelector } from 'react-redux';
import { routeConfigAdmintools, routesConfigBPKExternal } from '../../../../../pages/routesConfig';
import NavVerticalGroup from './VerticalNavGroup';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { AdminPenilaianRoutesConfigs } from '../../../../../pages/routesConfig';
import { useState, useEffect } from 'react';
import _ from "lodash";
import { Divider, Stack } from '@mui/material';
import { getDownloadMobileApp } from '@crema/services/apis/dashboard';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'shared/constants/ActionTypes';
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'
import { useDispatch } from 'react-redux';

const checkAccess = (userRoles, menuRoles) => {
  let permit = false;
  for (const value of menuRoles) {
    if (userRoles.includes(value)) {
      permit = true;
      break;
    }
  }
  return permit;
};

const VerticalNav = () => {
  let routesConfig = JSON.parse(localStorage.getItem('menu'))
  let config_copy = routesConfig[routesConfig.type];
  const { user } = useAuthUser();
  const { typeMenuHeader } = useSelector(state => state.common)
  const dispatch = useDispatch()

  // logika disamakan dengan HorizontalNav
  const render = (item) => {
    if (item.permitted_role && user.role.includes('honorer')) {
      return (
        <React.Fragment key={item.id}>
          {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

          {item.type === 'collapse' && (
            <VerticalCollapse item={item} level={0} />
          )}

          {(item.type === 'item' || item.type === 'nonGroup') && <VerticalItem item={item} level={0} />}
        </React.Fragment>
      )
    } else if (user.role.includes('honorer') && !item.roles_access) {
      return null
    } else {
      if (!item?.role_access) {
        return (
          <React.Fragment key={item.id}>
            {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

            {item.type === 'collapse' && (
              <VerticalCollapse item={item} level={0} />
            )}

            {(item.type === 'item' || item.type === 'nonGroup') && <VerticalItem item={item} level={0} />}
          </React.Fragment>
        )
      } else {
        // check if assosiated roles exists
        if (item.id === 'app-produk-hukum') {
          if (user.is_permitted === false && !checkAccess(user.roles_access, item.role_access)) {
            return null
          } else {
            return (
              <React.Fragment key={item.id}>
                {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

                {item.type === 'collapse' && (
                  <VerticalCollapse item={item} level={0} />
                )}

                {(item.type === 'item' || item.type === 'nonGroup') && <VerticalItem item={item} level={0} />}
                {item.type === 'divider' && <Divider sx={{ my: 5 }} />}
              </React.Fragment>
            )
          }
        }
        if (checkAccess(user.roles_access, item.role_access)) {
          return (
            <React.Fragment key={item.id}>
              {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

              {item.type === 'collapse' && (
                <VerticalCollapse item={item} level={0} />
              )}

              {(item.type === 'item' || item.type === 'nonGroup') && <VerticalItem item={item} level={0} />}
              {item.type === 'divider' && <Divider sx={{ my: 5 }} />}
            </React.Fragment>
          )
        }
      }
    }
  }
  const isAdminPenilaian = user.isAdminPenilaian;
  const [localRoutes, setLocalRoutes] = useState(null);
  const appMode = useSelector(({ appMode }) => appMode.mode);
  const [menuDownload, setMenuDownload] = useState({
    anchorEl: null,
    toggle: false,
  });

  const handleDownloadMobileApp = (type) => {
    dispatch({ type: FETCH_START })
    getDownloadMobileApp(type)
      .then(data => {
        const filename = data.results.name
        const fileurl = data.results.file

        const url = fileurl
        const link = document.createElement('a')

        link.href = url
        link.setAttribute(
          'download', filename + '.apk'
        )
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link);
        dispatch({ type: FETCH_SUCCESS })
      })
      .catch(error => {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Gagal Mengunduh Aplikasi',
        });
        console.log(error)
      })
  }

  useEffect(() => {
    if (appMode === 'admintools' && !("CRSFE_ADMIN_PENOMORAN" in user.roles_access)) {
      config_copy = _.cloneDeep(routeConfigAdmintools);
      setLocalRoutes(config_copy);
    } else if (appMode === 'bpk-external' && (!("BPK_DRIVE_EXTERNAL" in user.roles_access) || !("BPK_MONITORING" in user.roles_access))) {
      config_copy = _.cloneDeep(routesConfigBPKExternal);
      setLocalRoutes(config_copy);
    } else if (appMode === 'portal') {
      config_copy = routesConfig[routesConfig.type];
      if (isAdminPenilaian) {
        let tmp = config_copy.map((item) => {
          if (item.id === 'app') {
            item.children = item.children.map((cItem) => {
              if (cItem.id === 'mp') {
                cItem.children = [...cItem.children, ...AdminPenilaianRoutesConfigs]
                return cItem;
              } else {
                return cItem;
              }
            })
            return item;
          } else {
            return item;
          }
        });
        setLocalRoutes(tmp);
      } else {
        let tmp = [];
        for (let i = 0; i < config_copy.length; i++) {
          if (config_copy[i].id == 'app') {
            let tmp2 = config_copy[i].children;
            tmp.push(config_copy[i])
            tmp[i].children = [];
            for (let j = 0; j < tmp2.length; j++) {
              if (tmp2[j].id == 'mp' || tmp2[j].id == 'app-empsrv') {
                if (!user.email || user.email.slice(0, 4) != 'ses.') {
                  tmp[i].children.push(tmp2[j])
                }
              } else {
                tmp[i].children.push(tmp2[j])
              }
            }
          } else { tmp.push(config_copy[i]) }
        }
        setLocalRoutes(tmp);
      }
    }
  }, [appMode]);

  useEffect(() => {
    if (typeMenuHeader !== '' && appMode === 'portal') {
      setLocalRoutes(routesConfig[typeMenuHeader])
    }
  }, [typeMenuHeader])

  const handleOpenMenu = (event) => {
    setMenuDownload({
      anchorEl: event.currentTarget,
      toggle: true,
    });
  };

  const handleCloseMenu = (status = 0) => {
    if (status === 1) {
      handleDownloadMobileApp('android')
    }
    setMenuDownload({
      ...menuDownload,
      anchorEl: null,
      toggle: false
    });
  };

  return (
    localRoutes !== null && (
      <Stack direction={'column'}>
        <List
          sx={{
            position: 'relative',
            padding: 0,
            flex: 1
          }}
          component='div'
        >
          {localRoutes.map((item) => (
            render(item)
          ))}
        </List>

        {/* <ButtonContained
        variant="contained"
        disableElevation
        onClick={handleOpenMenu}
        sx={{ margin: 4 }}
      >

        <Typography>SuperApps</Typography>
      </ButtonContained> */}

        <DialogKonfirmasi
          open={menuDownload.toggle}
          handleClose={handleCloseMenu}
          labelPesan='Download Aplikasi'
          isiPesan={'Apakah anda yakin akan mengunduh aplikasi ?'}
          labelTombol='Unduh'
        />

      </Stack>
    )
  );
};

export default VerticalNav;
